import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { ApiParams } from '../../helpers/apiHelpers';
import { BillingPlanType } from './getBillingPlanDetailsApi';

export const getBillingPlansApi = (params?: ApiParams): Promise<ApiResponseType<ListResponseType<BillingPlanType>>> => {
  const uri = `/billing/plans/`;

  return authApiService.GET(uri, params);
};
